module.exports = __webpack_public_path__ + "img/start6.eff8a3f.png";